var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-table",
    {
      attrs: {
        emptyText: _vm.$t.__(
          "documents.overview.tab.dunning.DunningList.no_data"
        ),
        data: _vm.dunnings
      }
    },
    [
      _c("el-table-column", {
        attrs: { label: _vm.$t.__("common.labels.date"), width: "140" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(scope) {
              return [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.$filters.dateFormatter(
                        scope.row.date,
                        "SLASHED_DATE_TIME"
                      )
                    ) +
                    "\n        "
                )
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c("el-table-column", {
        attrs: {
          prop: "name",
          label: _vm.$t.__("documents.overview.tab.dunning.DunningList.dunning")
        }
      }),
      _vm._v(" "),
      _vm.hasDeadlines
        ? _c("el-table-column", {
            attrs: {
              label: _vm.$t.__(
                "documents.overview.tab.dunning.DunningList.due_date"
              )
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.getDeadlineInfo(scope.row.deadline_id)) +
                          "\n        "
                      )
                    ]
                  }
                }
              ],
              null,
              false,
              3653864374
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _c("el-table-column", {
        attrs: {
          prop: "sender",
          label: _vm.$t.__("documents.overview.tab.dunning.DunningList.sender")
        }
      }),
      _vm._v(" "),
      _c("el-table-column", {
        attrs: {
          prop: "recipient",
          label: _vm.$t.__(
            "documents.overview.tab.dunning.DunningList.recipient"
          )
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }